/**
 * All payment rows from applicant data (regular, voucher, group / lumpsum).
 * @param {Object} applicantData
 * @returns {Array}
 */
export function getAllPaymentsFromApplicant(applicantData) {
  return [
    ...(applicantData?.payments || []),
    ...(applicantData?.voucherPayments || []),
  ];
}

/**
 * Total paid amount across payments + voucherPayments + groupPayments.
 * @param {Object} applicantData
 * @returns {number}
 */
export function getBookingAmountTotalFromApplicant(applicantData) {
  return getAllPaymentsFromApplicant(applicantData).reduce(
    (sum, p) => sum + (Number(p?.paidAmount) || 0),
    0
  );
}
